import { VIcon } from "vuetify/lib";

export default {
	name: "TextChart",

	props: {
		cssClasses: {
			type: String,
			default: "text-center k-chart"
		},

		icon: String,

		header: {
			required: true,
			type: String
		},

		value: {
			required: true,
			type: [ Number, String ]
		}
	},

	render() {
		return <div class={this.cssClasses}>
			{this.icon && <div class="pa-2">
				<VIcon size="70">{this.icon}</VIcon>
			</div>}

			<div class="text-h2 pa-2">
				{this.value.toString().toUpperCase()}
			</div>

			<div class="text-h5 pa-2">
				{this.header.toUpperCase()}
			</div>
		</div>;
	}
};
